import { render, staticRenderFns } from "./C_Creator_EditQuests_Item_QuestBody_GameRules.vue?vue&type=template&id=a68a42f2&scoped=true&"
import script from "./C_Creator_EditQuests_Item_QuestBody_GameRules.vue?vue&type=script&lang=js&"
export * from "./C_Creator_EditQuests_Item_QuestBody_GameRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a68a42f2",
  null
  
)

export default component.exports